import React from "react";
import MarketPlaceOtherServicesIndex from "../components/marketplaceOtherServices";
import Footer from "../components/commonComponents/footer";
import Navbar from '../components/commonComponents/Navbar/Navbar';
import { useSelector } from "react-redux";
import PageLoader from "../common/pageLoader";

export default function MarketplaceOtherServices() {

    const { pageLoader } = useSelector(state => state.commonReducer);

    return (
        <div className={`${pageLoader && "body-overflow-hide"}`}>
            {/* <TopNavbar /> */}
            {pageLoader &&
                <PageLoader />
            }
            <Navbar />
            <MarketPlaceOtherServicesIndex />
            <Footer />
        </div>
    )
}